export function getCombatantStats({level, rpgClass}) {
  return {
    maxHp: 30 + (Number(level) * 2),
    attackStat: Number(level),
  }
}